import { render, staticRenderFns } from "./Overdraft.vue?vue&type=template&id=0bfc4fce&"
import script from "./Overdraft.vue?vue&type=script&lang=js&"
export * from "./Overdraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports